import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form_item, { label: _ctx.label }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          size: _ctx.size,
          style: {"width":"100%"},
          filterable: "",
          remote: "",
          "default-active-first-option": false,
          "show-arrow": false,
          "not-found-content": null,
          "remote-method": _ctx.handleSearch,
          onChange: _ctx.handleChange,
          loading: _ctx.loading,
          modelValue: _ctx.description,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.description) = $event)),
          placeholder: _ctx.placeholder
        }, {
          empty: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", null, "Could not find a matching location.", -1)
          ]))]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (d) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                value: d.place_id,
                label: d.display_name,
                key: d.place_id
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "App-Loc-Icon el-icon-location" }, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(d.display_name), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["value", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["size", "remote-method", "onChange", "loading", "modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["label"])
  ]))
}